import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import AppLayout from "../layouts/AppLayout";
import RouteSuspense from "./RouteSuspense";
import { AdminRoute, PasswordChangeRoute, ProtectedRoute, PublicOnlyRoute } from '@/components/system/AuthRoute';

const NotFound = lazy(() => import("../pages/NotFound"));
const Dashboard = lazy(() => import("../pages/dashboard/page"));
const Clientes = lazy(() => import("../pages/clientes/page"));
const Pacientes = lazy(() => import("../pages/pacientes/page"));
const HistoriaClinica = lazy(() => import("../pages/historia/page"));
const Agenda = lazy(() => import("../pages/agenda/page"));
const Productos = lazy(() => import("../pages/productos/page"));
const Stock = lazy(() => import("../pages/stock/page"));
const Ventas = lazy(() => import("../pages/ventas/page"));
const Caja = lazy(() => import("../pages/caja/page"));
const Configuracion = lazy(() => import("../pages/configuracion/page"));
const Proveedores = lazy(() => import("../pages/proveedores/page"));
const Auditoria = lazy(() => import("../pages/auditoria/page"));
const Recordatorios = lazy(() => import("../pages/recordatorios/page"));
const Reportes = lazy(() => import("../pages/reportes/page"));
const Login = lazy(() => import('../pages/login/page'));
const ChangePassword = lazy(() => import('../pages/login/change-password'));
const Usuarios = lazy(() => import('../pages/usuarios/page'));
const Finanzas = lazy(() => import('../pages/finanzas/page'));

const routes: RouteObject[] = [
  {
    element: <PublicOnlyRoute />,
    children: [{ path: '/login', element: <RouteSuspense><Login /></RouteSuspense> }],
  },
  {
    element: <PasswordChangeRoute />,
    children: [{ path: '/cambiar-clave', element: <RouteSuspense><ChangePassword /></RouteSuspense> }],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
      { path: "/", element: <RouteSuspense><Dashboard /></RouteSuspense> },
      {
        path: "/clientes",
        element: <RouteSuspense><Clientes /></RouteSuspense>,
      },
      {
        path: "/pacientes",
        element: <RouteSuspense><Pacientes /></RouteSuspense>,
      },
      {
        path: "/historia-clinica",
        element: <RouteSuspense><HistoriaClinica /></RouteSuspense>,
      },
      {
        path: "/agenda",
        element: <RouteSuspense><Agenda /></RouteSuspense>,
      },
      {
        path: "/sala-de-espera",
        element: <div className="p-6 text-gray-500">Sala de Espera - Próximamente (Versión 6)</div>,
      },
      {
        path: "/productos",
        element: <RouteSuspense><Productos /></RouteSuspense>,
      },
      {
        path: "/stock",
        element: <RouteSuspense><Stock /></RouteSuspense>,
      },
      {
        path: "/ventas",
        element: <RouteSuspense><Ventas /></RouteSuspense>,
      },
      {
        path: "/caja",
        element: <RouteSuspense><Caja /></RouteSuspense>,
      },
      {
        path: "/finanzas",
        element: <RouteSuspense><Finanzas /></RouteSuspense>,
      },
      {
        path: "/recordatorios",
        element: <RouteSuspense><Recordatorios /></RouteSuspense>,
      },
      {
        path: "/reportes",
        element: <RouteSuspense><Reportes /></RouteSuspense>,
      },
      {
        path: "/auditoria",
        element: <RouteSuspense><Auditoria /></RouteSuspense>,
      },
      {
        element: <AdminRoute />,
        children: [
          { path: "/configuracion", element: <RouteSuspense><Configuracion /></RouteSuspense> },
          { path: "/proveedores", element: <RouteSuspense><Proveedores /></RouteSuspense> },
          { path: "/usuarios", element: <RouteSuspense><Usuarios /></RouteSuspense> },
        ],
      },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <RouteSuspense><NotFound /></RouteSuspense>,
  },
];

export default routes;
